import { graphql } from "gatsby";
import React from "react";

import Layout from "../../components/layout";
import OnlineCoursePageComponent from "../../components/online-page";
import Seo from "../../components/seo";
import { ThemeContext } from "../../context/ThemeContext";
import { stripHtmlTags } from "../../utils/commonFunctions";

const OnlinePage = ({ data }) => {
  const { page, genericDetails } = data;

  const { title: pageTitle, acfOnlineCourses: pageDetails } = page || {};

  const { programCode } = pageDetails ?? {};
  const applyNow = `/application-form/?online_program&program_code=${programCode}&program_title=${encodeURIComponent(pageTitle)}`;
  const enquireNow = `/enquiry-form/?type=online_enquiry&program=${programCode}&program_title=${encodeURIComponent(pageTitle)}`;

  return (
    <ThemeContext.Consumer>
      {(theme) => (
        <Layout
          containerClass="w-full mx-auto"
          brandingOpts={{ ...theme }}
          applyNow={applyNow}
          enquireNow={enquireNow}
          showGrantsBanner={false}
        >
          <OnlineCoursePageComponent
            type={"Advanced"}
            page={page}
            genericDetails={genericDetails}
            theme={theme}
            applyNow={applyNow}
            enquireNow={enquireNow}
          />
        </Layout>
      )}
    </ThemeContext.Consumer>
  );
};

export const Head = ({ data }) => {
  const { page } = data ?? {};
  const { acfOnlineCourses } = page;
  const { courseInstructors, durationsAndPrices } = acfOnlineCourses;

  //temporary hack to get course details for structured data, replace with new acfFields
  const durations = durationsAndPrices.shift();

  const repeatCount = parseInt(durations?.duration) || 4;
  const comitmentHours = parseInt(durations?.timeHours) || 8;

  const instructors =
    courseInstructors?.flatMap((instructor) => ({
      "@type": "Person",
      name: instructor?.title,
      description: stripHtmlTags(instructor?.content),
      image: instructor?.featuredImage?.node?.mediaItemUrl || ""
    })) ?? [];

  const courseDetails = {
    description:
      page?.seoLegacy?.description ??
      page?.seo?.description ??
      page?.acfOnlineCourses?.courseIntroduction,
    name: page?.seoLegacy?.title ?? page?.seo?.title ?? page?.title,
    hasCourseInstance: [
      {
        "@type": "CourseInstance",
        courseMode: "Online",
        courseSchedule: {
          "@type": "Schedule",
          duration: `P${comitmentHours}H`,
          repeatCount: repeatCount,
          repeatFrequency: "Weekly"
        },
        instructor: instructors || []
      }
    ],
    offers: [
      {
        "@type": "Offer",
        category: "Paid"
      }
    ]
  };

  return (
    <Seo
      title={page?.seoLegacy?.title ?? page?.seo?.title ?? page.title}
      description={page?.seoLegacy?.description ?? page?.seo?.description}
      image={page?.globalConfig?.backgroundImage?.sourceUrl}
      translations={page?.translations}
      lang={page?.locale}
      courseDetails={courseDetails}
      meta={[
        {
          name: "robots",
          content: page?.seoLegacy?.robots ?? page?.seo?.robots
        }
      ]}
    />
  );
};

export const onlineCourseQuery = graphql`
  query ($slug: String!) {
    page: wpOnlineCourse(slug: { eq: $slug }) {
      ...onlineCourse
    }

    genericDetails: wp {
      ...WpSharedFragment
    }
  }
`;
export default OnlinePage;
